export const USER_START = 'user/user-start';
export const USER_SUCCESS = 'user/user-success';
export const USER_PROJECT_SUCCESS = 'user/user-project-success';
export const USER_ERROR = 'user/user-error';
export const USER_CLEAR = 'user/user-clear';
